import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CustomInputComponent } from './custom-input.page';
import { ReactiveFormsModule } from '@angular/forms';
@NgModule({
  declarations: [CustomInputComponent],
  imports: [CommonModule, IonicModule, ReactiveFormsModule],
  exports: [CustomInputComponent],
})
export class CustomInputModule {}
